module.exports = __webpack_public_path__ + "static/media/welcome.a1834b2e.jpg";